'use strict';

import { initHoverTitle } from './HoverTitle.js';
import { ModalManager } from './ModalManager.js';
import { mobileAndTabletCheck } from './Screen.js';

/**
 * Čata loga rediģēšanas funkcionalitāte
 * 1. add režīms - čata lapā čata režīms kad logs vislaik stāv atvērts un var rakstīt, bet nav rediģēšanas funkcionalitātes
 * 2. add režīms - miracle lapā čata logs atveras tikai tad kad ir jāievada jauns ieraksts, bet nevar rediģēt jau esošu ierakstu
 * 3. edit režīms - čata logs ir atvērts un var rediģēt jau esošu ierakstu
 * scroll lock - vajag tad kad ir rediģēšanas režīms, vai add režīmā kad kursors ir čata logā, lai neļautu skrollēt lapu, bet tikai čata logu
 * no edit režīma ejot laukā, vispirms čeko vai ir izmaiņas, ja ir tad prasa apstiprinājumu vai saglabāt izmaiņas vai nē (modālais) un locks joprojām paliek, ja nav tad vienkārši aizver logu un noņem lock
 */
export const ChatBoxEditable = {
    state: {
        active: false,
        visible: false,
        editMode: false,
        addMode: false,
        scrollLock: false,
        scrollAnimating: false,
        isPasting: false,
    },
    scrollAnim: {
        current: 0,
        start: 0,
        end: 0,
        diff: 0
    },
    heightAnim: {
        current: 0,
        start: 0,
        end: 0,
        diff: 0
    },
    modalManagerToken: null,
    config: {
        disableBR: true
    },
    init: function (options = {}) {
        this.modalMode = false;
        this.selector = options.selector || '.chatinputbox';
        this.outerSelector = options.outerSelector || '.floatingChat';
        this.alwaysVisible = options.alwaysVisible || false;

        this.$chatParentEl = $('.chatParent');
        this.$marginEl = $('.chatMargin');
        this.$heightEl = $('.chatHeight');
        this.heightEl = this.$heightEl.get(0);
        this.$scrollGetEl = $(document);
        this.$r1 = this.$heightEl.find('.r1').first();
        this.$r2 = this.$heightEl.find('.r2').first();

        this.$chatBox = $(this.selector);
        this.chatBox = $(this.selector).get(0);
        this.$parent = this.$chatBox.parent();
        this.$outerBox = $(this.outerSelector);

        this.$animateEl = this.$marginEl.length ? this.$marginEl : this.$parent;

        this.isMobileOrTablet = mobileAndTabletCheck();

        this.bindEvents();

        this.originalMarginBottom = this.currentMarginBottom = parseInt(this.$marginEl.css('paddingBottom'));
        if (isNaN(this.currentMarginBottom)) {
            this.originalMarginBottom = 0;
            this.currentMarginBottom = 0;
        }

        this.initHeights();
        this.updateHeight({
            init: true,
            forceupdate: true
        });
    },
    initHeights: function () {
        this.parentMaxHeight = parseInt(this.$parent.css('maxHeight')) || 0;
        this.parentHeightPrev = this.parentHeightCurrent = parseInt(this.$parent.height()) || 0;

        this.defaultHeight = this.$chatBox.data('defheight') || this.$chatBox.height();
        this.currentHeight = this.$chatBox.height();
        this.isMultiline = this.currentHeight > this.defaultHeight;

        this.$outerBox.toggleClass('isMultiline', this.isMultiline);
        this.isMultilineLast = this.isMultiline;
    },
    bindEvents: function () {
        // Čata loga dinamiskā augstuma mainīšana
        this.$chatBox.on('blur keyup input change', (event, data) => {
            if (event.key) {
                // neveicam update uz command taustiņiem
                if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Control', 'Shift', 'Alt', 'Meta', 'Enter'].indexOf(event.key) !== -1) {
                    return;
                }
            }
            this.updateHeight(data);
        });

        if (ChatBoxEditable.config.disableBR) {
            if (this.isMobileOrTablet) {
                this.$chatBox.on('keypress', (event) => {
                    // neļaut enteru, lai neievadītu jaunu rindu
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        return false;
                    }
                });
            } else {
                this.$chatBox.on('keypress', (event) => {
                    // neļaut enteru, lai neievadītu jaunu rindu, bet tikai nosūtītu čatu
                    if (event.key === 'Enter') {
                        if (event.shiftKey) {
                            setTimeout(() => { $('.cctarget-1').trigger("click"); }, 50);
                        } else {
                            setTimeout(() => { $('.cctarget-2').trigger("click"); }, 50);
                        }
                        event.preventDefault();
                        return false;
                    }
                });
            }
        }

        if (!this.isMobileOrTablet) {
            this.$outerBox.find('.cctarget-1, .cctarget-2').each(function() {
                const title = $(this).attr('title');
                if (title) {
                    $(this).removeAttr('title');
                    $(this).data('title', title);
                    $(this).data('nottclick', 1);
                    $(this).addClass('hoverTitlePc');
                }
            });
            if (this.$outerBox.find('.hoverTitlePc').length) {
                initHoverTitle('.hoverTitlePc', 'body', 1500);
            }
        }

        this.$chatBox.on('focus', (event) => {
            if (this.state.isPasting) {
                return;
            }

            // ieslēdzam rakstīšanas režīmu
            this.startModalMode();
        });

        this.$chatBox.on('blur', (event) => {
            if (this.state.isPasting) {
                return;
            }

            // pārbaudam vai var izslēgt rakstīšanas režīmu;
            const canExit = this.checkExitConditions();
            if (canExit) {
                this.stopModalMode();
            }
        });

        // Paste as plain text
        this.$chatBox.on('paste', (event) => {
            event.preventDefault();

            let txt = '';
            // @ts-ignore
            if (event.clipboardData || event.originalEvent.clipboardData) {
                // @ts-ignore
                txt = (event.originalEvent || event).clipboardData.getData('text/plain');
                // @ts-ignore
            } else if (window.clipboardData) {
                // @ts-ignore
                txt = window.clipboardData.getData('Text');
            }

            if (ChatBoxEditable.config.disableBR) {
                txt = txt.replace(/(\r\n|\n|\r)+/gm, " ");
                txt = txt.trim();
            }


            if (document.queryCommandSupported('insertText')) {
                document.execCommand('insertText', false, txt);
            } else {
                document.execCommand('paste', false, txt);
            }

            setTimeout(() => {
                this.state.isPasting = true;

                // 1. Pārrēķinām augstumus
                this.updateHeight({});

                // 2. Maģiskais triks: atņemam un uzreiz atdodam fokusu
                this.chatBox.blur();
                this.chatBox.focus();

                this.state.isPasting = false;
            }, 10);
        });

        // Resize
        $(window).on('jq-resize-end', (event, w) => {
            ChatBoxEditable.resize();
        });
    },

    startModalMode: function () {
        if (!this.modalMode) {
            return;
        }
        if (this.modalManagerToken) {
            // ja ir jau tokens, tad modal režīms ir jau ieslēgts, nav jāieslēdz atkārtoti;
            return;
            //ModalManager.close(this.modalManagerToken);
        }
        this.modalManagerToken = ModalManager.open({
            name: this.param || 'chat',
            locksScroll: true
        });
    },
    stopModalMode: function () {
        if (!this.modalMode) {
            return;
        }
        if (this.modalManagerToken) {
            ModalManager.close(this.modalManagerToken);
            this.modalManagerToken = null;
        }
        console.log('Modal mode stopped');
    },
    checkExitConditions: function () {
        // TODO: pārbaudam vai var izslēgt rakstīšanas režīmu;
        // te priekš edit mode jāpieliek papildus čekošana;
        if (this.exitEditModeCallback) {
            const canExit = this.exitEditModeCallback();
            if (!canExit) {
                return false;
            }
        }

        return true;
    },

    startEditMode: function (callback) {
        this.state.editMode = true;
        this.exitEditModeCallback = callback;
        this.startModalMode();
    },
    stopEditMode: function () {
        this.state.editMode = false;
        this.exitEditModeCallback = null;
        this.stopModalMode();
    },
    clearChatBox: function () {
        this.$chatBox.val('');
        this.$chatBox.trigger('change', { forceupdate: true });
    },

    focus: function () {

    },

    updateHeight: function (data) {
        const isInit = data && data.init;
        const forceUpdate = data && data.forceupdate;
        let skipScroll = data && data.skipscroll;
        const scrollToEnd = data && data.scrolltoend;

        const prevScrollTop = this.$parent.scrollTop();
        let previousHeight = this.currentHeight;

        // 1. Piefiksējam veco reālo augstumu pirms jebkādām izmaiņām
        const oldHeight = this.chatBox.offsetHeight;

        // 2. Ļaujam pārlūkam brīvi aprēķināt dabisko satura augstumu
        this.chatBox.style.height = 'auto';

        // 3. Nolasām jauno dabisko augstumu (pārlūks to sarēķina fona atmiņā)
        const newHeight = this.chatBox.scrollHeight;

        // 4. Fiksējam jauno augstumu, lai tas nesāk lēkāt
        this.chatBox.style.height = `${newHeight}px`;
        this.$parent.scrollTop(prevScrollTop);

        // 5. Iegūstam mūsu zelta starpību!
        // Ja diff > 0 (lauks kļuva lielāks, izpletās)
        // Ja diff < 0 (lietotājs izdzēsa tekstu, lauks sarāvās)
        const diff = Math.min(newHeight, this.parentMaxHeight) - Math.min(oldHeight, this.parentMaxHeight);

        this.parentHeightPrev = this.parentHeightCurrent;
        this.parentHeightCurrent += diff;
        if (newHeight >= this.parentMaxHeight || this.parentHeightCurrent > this.parentMaxHeight) {
            // Ja jaunais augstums pārsniedz maksimālo, tad fiksējam to pie maksimālā un ļaujam skrollam darboties
            this.parentHeightCurrent = this.parentMaxHeight;
        }
        let diffReal = this.parentHeightCurrent - this.parentHeightPrev;
        const prntHeightChanged = this.parentHeightPrev != this.parentHeightCurrent;
        //console.log('parentHeightCurrent:', this.parentHeightCurrent, 'parentHeightPrev:', this.parentHeightPrev, 'diffReal:', diffReal, 'prntHeightChanged:', prntHeightChanged);

        if (!prntHeightChanged && !forceUpdate) {
            skipScroll = true;
        }

        //console.log('Height update:', oldHeight, '->', newHeight, 'diff:', diff, 'parent height:', this.parentHeightCurrent, 'skipScroll:', skipScroll, 'scrollToEnd:', scrollToEnd);
        // ja mainijies ir augstums tad updeitojam augstumu;
        if (oldHeight != newHeight || forceUpdate) {

            // noņēmām css transition;
            //this.$parent.height(newHeight);

            if (skipScroll) {
                // skip scroll te ir ja mainijies ir textarea augstums, bet nav mainijies parent augstums.

                // TODO: te vai vajag animēt $parent height? ja nav mainijies? tātad tam scrolls ir aktīvs;
                //this.$parent.height(newHeight);

                if (!this.state.scrollAnimating) {
                    this.toggleScrollbarTimer(this.parentHeightCurrent < newHeight);
                }
            } else {
                this.updateAnimate(diffReal, newHeight, data);
            }
        }


        this.isMultiline = newHeight > this.defaultHeight;
        if (this.isMultiline != this.isMultilineLast) {
            this.$outerBox.toggleClass('isMultiline', this.isMultiline);
            this.isMultilineLast = this.isMultiline;
        }
    },
    updateAnimate: function (diffReal, newHeight, data) {
        //console.log('Animate update:', 'diffReal:', diffReal, 'newHeight:', newHeight);
        this.currentMarginBottom += diffReal;
        if (this.currentMarginBottom < this.originalMarginBottom) {
            diffReal = this.currentMarginBottom = this.originalMarginBottom;
        }

        // ja ir pievienots jauns čata ieraksts, tad pievienojam tā augstumu
        let scrolladd = 0;
        if (data && data.$newelement) {
            scrolladd = data.$newelement.outerHeight();
        }
        if (data && data.heightDiff) {
            scrolladd += data.heightDiff;
        }

        // ja notiek jau animācija, tad piefiksējam jauno augstuma starpību un turpinām animāciju no jaunās pozīcijas
        if (this.state.scrollAnimating) {
            // apturam iepriekšējo animāciju;
            this.$animateEl.stop(true, false);

            // animācijas sākumu uzliekam iepriekšējās beigas;
            this.scrollAnim.start = this.scrollAnim.current;

            // beigas liekam klāt pie iepriekšējām beigām;
            this.scrollAnim.end = this.scrollAnim.end + diffReal + scrolladd;
            //console.log('this.scrollAnim.start:', this.scrollAnim.start, 'this.scrollAnim.end:', this.scrollAnim.end, 'diffReal:', diffReal, 'scrolladd:', scrolladd);
            if (this.scrollAnim.end < 0) {
                this.scrollAnim.end = 0;
            }
            this.scrollAnim.diff = this.scrollAnim.end - this.scrollAnim.start;

            this.heightAnim.start = this.heightAnim.current;
            this.heightAnim.end = Math.min(newHeight, this.parentMaxHeight);
            this.heightAnim.diff = this.heightAnim.end - this.heightAnim.start;
        } else {
            this.scrollAnim.start = this.scrollAnim.current = this.animScrollGet();
            this.scrollAnim.end = Math.round(this.scrollAnim.start + diffReal + scrolladd);
            //console.log('this.scrollAnim.start:', this.scrollAnim.start, 'this.scrollAnim.end:', this.scrollAnim.end, 'diffReal:', diffReal, 'scrolladd:', scrolladd);
            if (this.scrollAnim.end < 0) {
                this.scrollAnim.end = 0;
            }
            this.scrollAnim.diff = this.scrollAnim.end - this.scrollAnim.start;

            this.heightAnim.start = this.heightAnim.current = this.$parent.height();
            this.heightAnim.end = Math.min(newHeight, this.parentMaxHeight);
            this.heightAnim.diff = this.heightAnim.end - this.heightAnim.start;
        }
        // console.log(this.scrollAnim.end);

        //console.log('this.scrollAnim.start', this.scrollAnim.start);
        if (data && data.scrolltoend) {
            // Pilnais lapas augstums
            const totalHeight = document.documentElement.scrollHeight;
            // Pārlūkprogrammas loga redzamais augstums
            const visibleHeight = window.innerHeight;
            // Aprēķinām atlikumu
            const pixelsToBottom = totalHeight - this.animScrollGet() - visibleHeight;

            //console.log('Scroll to end requested. totalHeight:', totalHeight, 'visibleHeight:', visibleHeight, 'currentScroll:', this.animScrollGet(), 'pixelsToBottom:', pixelsToBottom);

            this.scrollAnim.end = this.scrollAnim.start + pixelsToBottom;
            this.scrollAnim.diff = this.scrollAnim.end - this.scrollAnim.start;
        }

        //await nextFrame();

        this.state.scrollAnimating = true;
        if (this.$marginEl.length) {
            const r1Height = this.$r1.outerHeight() || 0;
            const r2Height = this.$r2.outerHeight() || 0;
            const parentElHeight = this.$heightEl.height() || 0;
            //console.log('parentElHeight > r1Height + r2Height', parentElHeight, r1Height + r2Height)
            if (parentElHeight > r1Height + r2Height) {
                const diff2 = parentElHeight - (r1Height + r2Height);
                //console.log('diff2:', diff2, 'this.scrollAnim.diff:', this.scrollAnim.diff);
                if (diff2 < this.scrollAnim.diff) {
                    this.scrollAnim.end = this.scrollAnim.start + this.scrollAnim.diff - diff2;
                    this.scrollAnim.diff = this.scrollAnim.end - this.scrollAnim.start;
                } else {
                    this.scrollAnim.end = this.scrollAnim.start;
                    this.scrollAnim.diff = 0;
                }
                //console.log(this.scrollAnim.start, this.scrollAnim.end, this.scrollAnim.diff);
            }
            //console.log(this.scrollAnim.end);
            //console.log('r1Height:', r1Height, 'r2Height:', r2Height, 'parentElHeight:', parentElHeight, 'currentMarginBottom:', this.currentMarginBottom);
            this.$animateEl
                .stop(true, false)
                .animate({ paddingBottom: this.currentMarginBottom }, {
                    duration: data && data.init ? 0 : 190,
                    easing: 'linear',
                    step: (now, tween) => {
                        //self.heightCurrent = self.heightFunc() - Math.round(now);
                        this.scrollAnim.current = this.scrollAnim.start + Math.round(this.scrollAnim.diff * tween.pos);
                        this.heightEl.style.setProperty('min-height', 'calc(var(--real-vhxx, 100dvh) - ' + Math.round(now) + 'px)');
                        this.animScrollSet(this.scrollAnim.current);

                        //console.log('heightEl', 'calc(var(--real-vh, 100dvh) - ' + Math.round(now) + 'px)');

                        this.heightAnim.current = this.heightAnim.start + Math.round(this.heightAnim.diff * tween.pos);
                        this.$parent.height(this.heightAnim.current);
                        //console.log('this.heightAnim.current', this.heightAnim.current);
                    },
                    complete: () => {
                        this.heightEl.style.setProperty('min-height', 'calc(var(--real-vhxx, 100dvh) - ' + this.currentMarginBottom + 'px)');
                        this.animScrollSet(this.scrollAnim.end);
                        this.$parent.height(this.heightAnim.end);

                        this.toggleScrollbarTimer(this.parentHeightCurrent < newHeight);

                        this.state.scrollAnimating = false;
                    },
                    always: function () {

                    }
                });
        } else {
            this.toggleScrollbarTimer(this.parentHeightCurrent < newHeight);

            this.$animateEl
                .stop(true, false)
                .animate({ height: this.heightAnim.end }, {
                    duration: data && data.init ? 0 : 190,
                    easing: 'linear',
                    complete: () => {
                        this.toggleScrollbarTimer(this.parentHeightCurrent < newHeight);
                        this.state.scrollAnimating = false;

                        /* if (lockScroll) {
                            setTimeout(function () {
                                likechatEditModeOn();
                            }, 100);
                        } */
                    },
                    always: function () {

                    }
                });
        }

    },
    resize: function () {
        this.initHeights();
        this.updateHeight({
            forceupdate: true
        });
    },

    animScrollGet: function () {
        if (this.modalManagerToken) {
            //console.log('Getting scroll top from modal manager');
            return ModalManager.getScrollTop();
        }
        //console.log('Getting scroll top from window');
        return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    animScrollSet: function (value) {
        if (this.modalManagerToken) {
            return ModalManager.setScrollTop(value);
        }
        window.scrollTo({
            top: value,
            behavior: 'instant'
        });
    },

    toggleScrollbarTimer: function (enable) {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            this.toggleScrollbar(enable);
        }, 300);
    },
    toggleScrollbar: function (enable) {
        this.$parent.toggleClass('thinscroll', enable);
    }
};

export function createOutclickerOverlay() {
    const $el = $('.outclicker-ov-before');
    if (!$el.length) {
        return null;
    }

    removeOutclickerOverlay();

    const $overlay = $('<div class="overlayOutclickerChat"></div>');
    $el.before($overlay);

    return $overlay;
}
export function removeOutclickerOverlay() {
    $('.overlayOutclickerChat').remove();
}

export function likechatEditModeOn() {
    // TODO: fix scroll;
    if ($('body').hasClass('chat-scroll-animating')) {
        return;
    }
    //$(window).trigger('lm.chatEditModeOn');
}
export function likechatEditModeOff() {
    // TODO: fix scroll;
    //$(window).trigger('lm.chatEditModeOff');
}